import { useQuery } from "@tanstack/react-query";
import { getCxMappingsByCxId } from "../../api/ehr";
import { CxMapping } from "../../api/ehr";

const CX_MAPPING_QUERY_KEY = "cx-mapping";

export function useCxMappingQuery(cxId: string | undefined) {
  return useQuery<CxMapping[], Error>({
    queryKey: [CX_MAPPING_QUERY_KEY, cxId],
    queryFn: async () => {
      if (!cxId) return [];
      return await getCxMappingsByCxId(cxId);
    },
    enabled: !!cxId,
    meta: { errorMessage: "Failed to load CX mappings" },
  });
}
